'use client';

import type { projects } from '@flowmuse/schema';
import { type ReactNode, createContext, useContext, useMemo } from 'react';

type Project = typeof projects.$inferSelect;

type ProjectContextType = {
  project: Project | null;
};

export const ProjectContext = createContext<ProjectContextType>({
  project: null,
});

export const useProject = () => {
  const context = useContext(ProjectContext);

  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }

  return context.project;
};

export const ProjectProvider = ({
  children,
  data,
}: {
  children: ReactNode;
  data: Project;
}) => {
  const value = useMemo(() => ({ project: data }), [data]);

  return (
    <ProjectContext.Provider value={value}>
      {children}
    </ProjectContext.Provider>
  );
};
